module.exports = __webpack_public_path__ + "img/IMG_9215.379b6c65.jpg";